import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { ECharts } from 'echarts';
import * as echarts from 'echarts';
import * as _ from 'lodash';
import * as backgroundColor from '../../config/backgroundColor';
import * as color from '../../config/colors';
import { initOpts } from '../../config/initOpts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ScatterMapService } from './scatter-map.service';
import { cloneDeep } from 'lodash';
import { ChartResizeService } from '../../service/chart-resize.service';

@Component({
  selector: 'bcac-scatter-map',
  templateUrl: './scatter-map.component.html',
  styleUrls: ['./scatter-map.component.scss']
})
export class ScatterMapComponent implements OnInit {

  constructor(
    private scatterMapService: ScatterMapService,
    private commonService: CommonService,
    private chartResizeService: ChartResizeService,
    private http: HttpClient
  ) { }

  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      let style = this.commonService.changeFontSize();
      this.chartResizeService.autoMapResizeAdapt(this.echartInstance, this.chartOption)
      // this.commonService.setMapChartResize(this.echartInstance, style);
    })
  }

  chartOption: any = this.scatterMapService.getScatterMapDefaultOptions();


  _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "地图"
  }

  // 输入标题
  @Input()
  set bcacChartTitleText(chartTitle: string) {
    this._bcacChartTitle.label = chartTitle
  }
  // 输入标题是否显示
  @Input()
  set bcacChartShowTitle(showTitle: boolean) {
    this._bcacChartTitle.show = showTitle
  }
  // 下载图片文件名
  _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }

  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  // 修改visualMap类型
  // @Input()
  // set bcacVisualMap(
  //   visualMap: {
  //     type: "continuous";
  //     data: { min: number; max: number; color?: string[] }
  //   }
  //     | { type: "piecewise"; data: { [key: string]: any }[] }
  // ) {
  //   this.scatterMapService.changeVisualMap(this.chartOption, visualMap);
  //   this.updateOption();
  // }


  // 地图文件路径
  _mapUrl: string = "";
  @Input()
  set bcacMapUrl(mapUrl: string) {
    this._mapUrl = mapUrl;
    // this.updateMapUrl();
  }

  // 下拉框列表数据
  _selectList: { value: string | number, optList: { label: string, value: any }[] }[] = [];
  // 数据选择区域
  @Input()
  set bcacDataSourceList(selectList: any) {
    if (Array.isArray(selectList)) {
      if (selectList.length > 0 && selectList[0].hasOwnProperty('optList')) {
        this._selectList = selectList;
      } else {
        this._selectList = [];
      }
    } else {
      this._selectList = []
    }
  }

  bcacData: any = []
  _visualMapType = 'continuous';
  visualMapPosition: 'left' | 'right' = 'left';
  // 图数据
  @Input()
  set bcacChartData(chartData: any) {

    if (chartData.hasOwnProperty('data')) {
      if (chartData.hasOwnProperty('visualMap') && chartData.visualMap.hasOwnProperty('type')) {
        this._visualMapType = chartData.visualMap.type;
      }

      this.scatterMapService.changeVisualMap(this.chartOption, this.visualMapPosition, chartData.visualMap, this._bcacDimension, this.isDarkMode);
      this.scatterMapService.changeChartData(this.chartOption, chartData.data)

    } else {
      this.scatterMapService.changeChartData(this.chartOption, [])
    }
    this.updateMapUrl();
  }

  @Input()
  set bcacChartShowToolbox(chartShowToolbox: boolean) {
    // this.scatterMapService.changeToolboxShow(this.chartOption, chartShowToolbox)
  }

  _bcacDimension: number = 2;
  // 设置维度
  @Input()
  set bcacDimension(dimension: number) {
    this._bcacDimension = dimension;
    this.scatterMapService.changeVisualmapDimension(this.chartOption, dimension);
    // this.updateMapUrl();
  }

  // 设置dimension名
  @Input()
  set bcacDimensionNames(dimensionNames: { [key: string]: string }[]) {
    this.scatterMapService.changeDimensionNames(this.chartOption, dimensionNames)
    // this.updateMapUrl();
  }

  //设置visualmap位置 
  @Input()
  set bcacVisualMapPosition(position: 'left' | 'right') {
    this.visualMapPosition = position;
    this.scatterMapService.changeVisualMapPosition(this.chartOption, position)
    // this.updateMapUrl();
  }

  isDarkMode: boolean = false;
  // 设置黑暗模式
  @Input()
  set bcacDarkMode(darkMode: boolean) {

    this.isDarkMode = darkMode;

    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.scatterMapService.openDarkMode(this.chartOption, darkMode);
  }

  isSmallMode: boolean = false;
  _cardPadding = "1rem";
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding(smallMode);
    } else {
      this.isSmallMode = false;
    }

  }

  // 设置geoLabel显示状态
  @Input()
  set bcacGeoShowLabel(show: boolean) {
    this.scatterMapService.changeGeoShowLabel(this.chartOption, show);
  }


  @Output() bcacDataSourceSelectEmit: EventEmitter<any[]> = new EventEmitter<any[]>();

  echartInstance: ECharts;
  onOptionInit($event) {
    this.echartInstance = $event;
  }

  updateOption() {
    if (this.echartInstance) {
      this.echartInstance.setOption(this.chartOption, true)
    }
  }
  // 更改地图
  updateMapUrl() {
    this.http.get(this._mapUrl).subscribe((geoJson) => {
      echarts.registerMap('myMap', geoJson);
      if (this.echartInstance) {
        this.echartInstance.setOption(this.chartOption, true)
      }
    })
  }

  isNotSingleData: boolean = false;

  dataSourceList: { name: string, data: any }[] = [];

  selectedData: string = "";

  // 改变数据源
  // selectedDataChange($event) {
  //   this.bcacData.forEach(element => {
  //     if (element.name === $event) {
  //       this.scatterMapService.changeVisualMap(this.chartOption, element.visualMap, this._bcacDimension)
  //       this.scatterMapService.changeChartData(this.chartOption, element.data)
  //       this.updateOption();
  //       return;
  //     }
  //   })
  // }

  // 选择数据源切换
  selectedDataSourceChange($event) {
    this.bcacDataSourceSelectEmit.emit($event);
  }
  _chartTitleColor = '';
  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this._chartTitleColor = ''
    } else {
      this._chartTitleColor = color.darkModeTextColor;
    }
  }

  _cardBackgroundColor = "#FFF";
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this._cardBackgroundColor = darkMode;
    } else if (darkMode) {
      this._cardBackgroundColor = backgroundColor.darkModeBGColor;
    }
  }

  // 改变卡片padding
  changeCardPadding(smallMode: boolean) {
    if (smallMode) {
      this._cardPadding = '0rem';
    } else {
      this._cardPadding = '1rem';
    }
  }

  chartRestore() {
    if (this.echartInstance) {
      this.echartInstance.dispatchAction({
        type: 'restore'
      })
    }
  }
}
